import React, { FunctionComponent, useState } from "react";
import { Aside, ListActionButtonProps } from "sprint-common-web";

import { EditListButton } from "../../../../../common/components/buttons/EditListButton";
import { EditLanguageSpecificationMappingForm } from "../forms/EditLanguageSpecificationMappingForm";
import { ManzanitaMuxSpecificationLanguageMappingListingItem } from "../ManzanitaMuxSpecificationLanguageMappingsSection";

type EditLanguageSpecificationButtonProps = ListActionButtonProps<ManzanitaMuxSpecificationLanguageMappingListingItem>;

export const EditLanguageSpecificationButton: FunctionComponent<EditLanguageSpecificationButtonProps> = (
    props: EditLanguageSpecificationButtonProps
) => {
    const { disabled, itemId } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <EditListButton onClick={openAside} disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Edit language specification"} onDismiss={closeAside}>
                <EditLanguageSpecificationMappingForm
                    languageId={itemId}
                    onCancel={closeAside}
                    onSubmit={handleFormSubmit}
                />
            </Aside>
        </>
    );
};
